import React from 'react';
import { LABEL } from '../../veriables';
import { getImageUrl } from '@utility/utills';
import style from './orderItemDetail.module.scss';
import cn from 'classnames';
import warningImage from '@assets/images/warning-black.png';

const MoreInfo = ({
  ItemDetails,
  itemDetailsInfo
}) => {
  const getBadgeName = (menuItem) => {
    if (menuItem.outOfStock) {
      return LABEL().OUT_OF_STOCK;
    }

    const badgeNameMap = {
      1: LABEL().VIEW_ONLY,
      2: LABEL().NEW_ITEM,
      3: LABEL().LIMITED_TIME,
      4: LABEL().FEATURED,
      5: LABEL().SPECIAL,
      6: LABEL().COMING_SOON,
      7: LABEL().LIMITED_QUANTITY,
      8: LABEL().ADDITIONAL_TIME,
      9: LABEL().TIME_RESTRICTED,
    };

    return badgeNameMap[menuItem.badge] || '';
  };

  const getBadgeStyle = (menuItem) => {
    if (menuItem.outOfStock) {
      return 'od-badge-nostock';
    }

    const badgeStyleMap = {
      1: 'od-badge-view',
      2: 'od-badge-new',
      3: 'od-badge-limited',
      4: 'od-badge-featured',
      5: 'od-badge-special',
      6: 'od-badge-comingsoon',
      7: 'od-badge-limitedquantity',
      8: 'od-badge-additionaltime',
    };

    return badgeStyleMap[menuItem.badge] || '';
  };

  return (
    <div className="h-100 od-text-primary">
      <div className="h-40">
        <div className="h-65">
          {(ItemDetails?.imageUrl) ? (
            <img src={getImageUrl(ItemDetails, 'itemDetail', window.screen.width)} alt="" className={cn(style.itemImage, getImageUrl(ItemDetails, 'itemDetail', window.screen.width) ? '' : 'd-none', 'img-fluid mx-auto')} />
          ) : (
            <img src={getImageUrl(ItemDetails.imageUrl)} alt="" className={cn(style.itemImage, getImageUrl(ItemDetails.imageUrl) ? '' : 'd-none', 'img-fluid mx-auto')} />
          )}
        </div>
        {getBadgeName(ItemDetails) && (
        <span style={{ top: 0 }} className={cn(style.removeOutStock, getBadgeStyle(ItemDetails), 'position-absolute fs-14')}>{getBadgeName(ItemDetails)}</span>
        )}
        <div id="itemName" className={cn('row mx-0 p-2 fs-20 fw-600 od-header-font-family')}>
          <div className="col-8 px-0 text-uppercase">{ItemDetails.name ? ItemDetails.name : '' }</div>
          <div className="col-4 px-0 text-right">{LABEL().CURRENCY_SYMBOL}{(itemDetailsInfo.price).toFixed(2)}</div>
        </div>
        <div className={cn('text-left px-2', style.tagContainer)}>
          {ItemDetails.tags.map((tag) => {
            return (
              <small key={tag.tagId} className={cn('badge fs-12', style.tagName)}>
                {tag.display && (
                <>
                  {tag.imageUrl ? (
                    <div className>
                      <img src={tag.imageUrl} alt={tag.shortName} width="25" height="20" className={cn(style.tagImg)} />
                    </div>
                  ) : (
                    tag.shortName && (
                    <div className={cn(style.tagTextBox)} style={{ color: tag.color }}>
                      {tag.shortName}
                    </div>
                    )
                  )}
                </>
                )}
              </small>
            );
          })}
        </div>
      </div>
      <div className="h-60 my-3 overflowY">
        {ItemDetails.description && (
          <div className="p-2 fs-20">
            {ItemDetails.description}
          </div>
        )}
        {(ItemDetails.disclaimer) && (
          <div className={cn('row fs-18 p-2 mx-2 rounded od-disclaimer-background bg-red align-items-center justify-content-center')}>
            <img className="col-1 px-0" src={warningImage} alt="" />
            <div className="col-11 px-1">{ItemDetails.disclaimer}</div>
          </div>
        )}
        {(ItemDetails.nutritionFact) && (
          <div className="p-2">
            <div className={`d-flex justify-content-start ${style.borderBottom}`}>
              <div className={cn('fs-24 fw-600 w-100 pb-2')}>{LABEL().NUTRITION_FACT}</div>
            </div>
            {ItemDetails?.nutritionFact ? (
              <div className="px-2 fs-22">
                <div className={cn('fs-20')}>
                  {ItemDetails.nutritionFact.amountPerServing} servings per container
                </div>
                <div className="row mx-0 fw-600 fs-20">
                  <div className="col-8 px-0 text-left">
                    Serving Size
                  </div>
                  <div className="col-4 px-0 text-right">
                    {ItemDetails.nutritionFact.servingSize}
                  </div>
                </div>
                <div className={cn(style.thickBorder)} />
                <div className={cn('row mx-0 fs-20 fw-700')}>
                  <div className={cn('col-8 fs-18 text-left')}>
                    Amount per serving
                    <div className={cn('fs-20')}>
                      Calories
                    </div>
                  </div>
                  <div className={cn('fs-22 col-4 px-0 row mx-0 align-items-center justify-content-end')}>
                    {ItemDetails.nutritionFact.calories}
                  </div>
                </div>
                <div className={cn(style.thick3pxBorder)} />
                <div>
                  <div className={cn(style.borderBottom, 'd-flex justify-content-end mx-2 fw-600 flex-row')}>
                    <div className="">
                      {ItemDetails.nutritionFact.amountPerService}% Daily Value*
                    </div>
                  </div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 fw-600 flex-row')}>
                  <div className="col p-0">
                    Total Fat{" "}
                    <span className="fw-100 px-1">
                      {ItemDetails.nutritionFact.totalFat}g
                    </span>
                  </div>
                  <div className="col pr-0 d-flex justify-content-end">
                    <span>{ItemDetails.nutritionFact.totalFatPercentDaily}%</span>
                  </div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                  <div className="col pr-0">
                    Saturated Fat{" "}
                    <span className="fw-100 px-1">
                      {ItemDetails.nutritionFact.saturatedFat}g
                    </span>
                  </div>
                  <div className="col p-0 d-flex justify-content-end fw-600">
                    <span>{ItemDetails.nutritionFact.saturatedFatPercentDaily}%</span>
                  </div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 flex-row')}>
                  <div className="col pr-0">
                    Trans Fat{" "}
                    <span className="px-1">
                      {ItemDetails.nutritionFact.transFat}g
                    </span>
                  </div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 fw-600 flex-row')}>
                  <div className="col p-0">
                    Cholesterol{" "}
                    <span className="fw-100 px-1">
                      {ItemDetails.nutritionFact.cholesterol}mg
                    </span>
                  </div>
                  <div className="col pr-0 d-flex justify-content-end">
                    <span>{ItemDetails.nutritionFact.cholesterolPercentDaily}%</span>
                  </div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 fw-600 flex-row')}>
                  <div className="col p-0">
                    Soduim{" "}
                    <span className="fw-100 px-1">
                      {ItemDetails.nutritionFact.sodium}mg
                    </span>
                  </div>
                  <div className="col pr-0 d-flex justify-content-end">

                    <span>{ItemDetails.nutritionFact.sodiumPercentDaily}%</span>
                  </div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 fw-600 flex-row')}>
                  <div className="">
                    Total Carbohydrate{" "}
                    <span className="fw-100 px-1">
                      {ItemDetails.nutritionFact.totalCarbohydrate}g
                    </span>
                  </div>
                  <div>{ItemDetails.nutritionFact.totalCarbohydratePercentDaily}%</div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 flex-row')}>
                  <div className="col pr-0">
                    Dietary Fiber{" "}
                    <span className="px-1">
                      {ItemDetails.nutritionFact.dietaryFiber}g
                    </span>
                  </div>
                  <div className="col p-0 d-flex justify-content-end fw-600">
                    <span>{ItemDetails.nutritionFact.dietaryFiberPercentDaily}%</span>
                  </div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 flex-row')}>
                  <div className="col pr-0">
                    Total Sugars{" "}
                    <span className="px-1">
                      {ItemDetails.nutritionFact.totalSugar}g
                    </span>
                  </div>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 flex-row')}>
                  <div className="col pl-30">Includes {ItemDetails.nutritionFact.addedSugar}g Added Sugars</div>
                  <span className="">
                    {ItemDetails.nutritionFact.totalSugarPercentDaily}%
                  </span>
                </div>
                <div className={cn('d-flex justify-content-between px-2 fw-600 flex-row')}>
                  <div className="col p-0">
                    Protein{" "}
                    <span className="fw-100 px-1">
                      {ItemDetails.nutritionFact.protein}g
                    </span>
                  </div>
                </div>
                <div className={cn(style.thickBorder, 'px-2')} />
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 flex-row')}>
                  <span>Vitamin D {ItemDetails.nutritionFact.vitaminD}mcg</span>
                  <span>{ItemDetails.nutritionFact.vitaminDPercentDaily}%</span>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 flex-row')}>
                  <span>Calcium {ItemDetails.nutritionFact.calcium}mg</span>
                  <span>{ItemDetails.nutritionFact.calciumPercentDaily}%</span>
                </div>
                <div className={cn(style.borderBottom, 'd-flex justify-content-between px-2 flex-row')}>
                  <span>Iron {ItemDetails.nutritionFact.iron}mg</span>
                  <span>{ItemDetails.nutritionFact.ironPercentDaily}%</span>
                </div>
                <div className={cn('d-flex justify-content-between px-2 flex-row')}>
                  <span>Potassium {ItemDetails.nutritionFact.potassium}mg</span>
                  <span>{ItemDetails.nutritionFact.potassiumPercentDaily}%</span>
                </div>
                <div className={cn(style.thick3pxBorder, 'px-2')} />
                <div className="d-flex justify-content-between px-2 fs-16">
                  * The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories
                  a day is used for general nutrition advice.
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center">No nutrition fact details available</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MoreInfo;
